import React from "react";

// Showcase items with actual generated content examples
const showcaseItems = [
  {
    id: "team-announcement",
    title: "Team Announcement",
    description: "Professional team lineup graphics",
    category: "Team",
    gradient: "from-snaptrix-blue-600 to-snaptrix-blue-400",
    imageUrl: "/examples/old-Leos-Playing-eleven-021 (6).jpg",
  },
  {
    id: "match-summary",
    title: "Match Summary",
    description: "Engaging post-match highlights",
    category: "Match",
    gradient: "from-purple-500 to-pink-500",
    imageUrl: "/examples/Match-summary-006.jpg",
  },
  {
    id: "top-performance",
    title: "Top Performance",
    description: "Celebrate standout players",
    category: "Performance",
    gradient: "from-yellow-400 to-orange-500",
    imageUrl: "/examples/old-Leos-Man-of-the-match-8 (2).jpg",
  },
  {
    id: "milestones",
    title: "Milestones",
    description: "Achievement celebrations",
    category: "Achievement",
    gradient: "from-green-500 to-emerald-600",
    imageUrl: "/examples/Cricket Player Milestone Post.png",
  },
  {
    id: "fixtures",
    title: "Fixtures",
    description: "Upcoming match schedules",
    category: "Schedule",
    gradient: "from-indigo-500 to-purple-600",
    imageUrl: "/examples/Fixtures_1_Match (1).jpg",
  },
  {
    id: "leaderboard",
    title: "Leaderboard",
    description: "Player statistics & rankings",
    category: "Stats",
    gradient: "from-red-500 to-pink-600",
    imageUrl: "/examples/Leaderboard.jpg",
  },
];

export default function ShowcaseSection() {
  return (
    <section className="py-16 md:py-20 bg-gradient-to-b from-white via-snaptrix-blue-50 to-white" aria-labelledby="showcase-heading">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2
            id="showcase-heading"
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-snaptrix-gray-700 mb-4"
          >
            See What You Can Create
          </h2>
          <p className="text-lg md:text-xl text-snaptrix-gray-600 max-w-2xl mx-auto">
            Professional graphics ready to share in seconds. No design skills needed.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {showcaseItems.map((item) => (
            <div
              key={item.id}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105"
            >
              {/* Gradient Background */}
              <div className={`absolute inset-0 bg-gradient-to-br ${item.gradient} opacity-90 group-hover:opacity-95 transition-opacity duration-300`} />
              
              {/* Content Overlay */}
              <div className="relative p-6 md:p-8 flex flex-col justify-between text-white min-h-[320px] md:min-h-[360px]">
                {/* Category Badge */}
                <div className="inline-block mb-3">
                  <span className="px-3 py-1.5 bg-white bg-opacity-25 backdrop-blur-md rounded-full text-xs font-semibold uppercase tracking-wide shadow-md">
                    {item.category}
                  </span>
                </div>
                
                {/* Title and Description */}
                <div className="mb-4">
                  <h3 className="text-xl md:text-2xl lg:text-3xl font-bold mb-2 drop-shadow-md">
                    {item.title}
                  </h3>
                  <p className="text-white text-opacity-95 text-sm md:text-base leading-relaxed">
                    {item.description}
                  </p>
                </div>
                
                {/* Generated Content Image */}
                {item.imageUrl && (
                  <div className="mt-auto rounded-xl overflow-hidden border-2 border-white border-opacity-40 shadow-2xl group-hover:border-opacity-60 transition-all duration-300 relative">
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 pointer-events-none" />
                    <img
                      src={item.imageUrl}
                      alt={`${item.title} example - ${item.description}`}
                      className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        
        {/* Call to Action */}
        <div className="text-center mt-12">
          <p className="text-snaptrix-gray-600 mb-4">
            Want to see more examples? Get in touch for a personalized demo.
          </p>
        </div>
      </div>
    </section>
  );
}
